import type { DecisionMakerReference } from '../scopeMatch';

/**
 * A legislative-body group as exposed by the petition's dmsWithLegislativeBodiesConnection: each
 * group holds an ordered list of decision makers.
 */
type DecisionMakerGroup = Readonly<{
	decisionMakers: ReadonlyArray<Readonly<{ id: string; displayName: string }>>;
}>;

/**
 * Picks the petition's primary decision maker: the first DM of the first group. There is no "primary"
 * flag in the schema; ordering comes from the middle-end. Returns null when the petition has no
 * decision makers.
 */
export function selectPrimaryDecisionMaker(groups: readonly DecisionMakerGroup[]): DecisionMakerReference | null {
	const dm = groups.at(0)?.decisionMakers.at(0);
	return dm ? { id: dm.id, displayName: dm.displayName } : null;
}
